module.exports = __webpack_public_path__ + "static/RR2-a288880b9b587faf74a9827be52d0429.jpg";